import React, { useState } from "react"
import styles from "./Services.module.css"
import FadeInSection from "../FadeInSection/FadeInSection"
import { SRLWrapper } from "simple-react-lightbox"
import bathroom from "../../images/ServiceImages/bathroom.jpg"
import backsplash from "../../images/ServiceImages/backsplash.jpg"
import cabinet from "../../images/ServiceImages/cabinet.jpg"
import deck from "../../images/ServiceImages/deck.jpg"
import fence from "../../images/ServiceImages/fence.jpg"
import flooring from "../../images/ServiceImages/flooring.jpg"
import interlock from "../../images/ServiceImages/interlock.jpg"
import kitchen from "../../images/ServiceImages/kitchen.jpg"
import siding from "../../images/ServiceImages/siding.jpg"
import patio from "../../images/ServiceImages/patio.jpg"
import basement from "../../images/ServiceImages/basement.jpg"
import painting from "../../images/ServiceImages/painting.jpg"

const options = {
  buttons: {
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
    showAutoplayButton: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
}

const Services = () => {
  const services = {
    bathroom: {
      img: bathroom,
      text:
        "From the small things like fixtures to redesigning your entire bathroom we do it all no matter how big or small.",
    },
    backsplash: {
      img: backsplash,
      text:
        "Protect your walls and add some style with a backsplash! Having a backsplash installed will prevent frequent water contact from becoming serious damage later on.",
    },
    cabinet: {
      img: cabinet,
      text:
        "Outdated cabinets? No problem, we got you covered. We install new and in style cabinets with ease.",
    },
    deck: {
      img: deck,
      text:
        "Spend your summers outside with the BBQ! Decks not only make a great outside hangout, they also increase the value of your home.",
    },
    fence: {
      img: fence,
      text:
        "A fence will add privacy and saftey to your home, all while being decorative. ",
    },
    flooring: {
      img: flooring,
      text:
        "Upgrade those old floors for something new and in style! We install all types of flooring for all types of budgets.",
    },
    interlock: {
      img: interlock,
      text:
        "Add that wow factor to your home with some interlock. We install easy to maintain, durable interlock that will boost the value of your home.",
    },
    kitchen: {
      img: kitchen,
      text:
        "A lot goes on in the kitchen, we know your kitchen is an important area of your home. An improvment in the kitchen can bring smiles to all.",
    },
    siding: {
      img: siding,
      text:
        "Get the look you are after while maintaining durability. We ofter siding installation at an afforable price.",
    },
    patio: {
      img: patio,
      text:
        "Like to entertain? Spend more time in your yard with a brand new patio!",
    },
    basement: {
      img: basement,
      text:
        "Unfinished basement? Transform your basement in to an area you can enjoy. ",
    },
    painting: {
      img: painting,
      text:
        "Enhance curb appeal and make your house pop with a fresh coat of paint.",
    },
  }

  const [selectedInteriorService, setSelectedInteriorService] = useState(
    services.flooring
  )
  const [selectedExteriorService, setSelectedExteriorService] = useState(
    services.fence
  )
  const [isActiveInterior, setIsActiveInterior] = useState("flooring")
  const [isActiveExterior, setIsActiveExterior] = useState("fence")

  return (
    <div className={styles.container} id="services-page">
      <div className={styles.content}>
        <FadeInSection>
          <SRLWrapper options={options}>
            <div className={styles.description}>
              <h1 className="bigTitle">What we have to offer</h1>
              <h2 className="smallTitle">
                We offer a variety of services for both the interior and
                exterior of your home
              </h2>
              <div className="line"></div>
            </div>
            <section className={styles.servicesSection}>
              <div className={styles.servicesContainer}>
                <div className={styles.servicesContent}>
                  <h1 className={styles.servicesTitle}>Interior Services</h1>
                  <ul className={styles.renovationList}>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.flooring)
                          setIsActiveInterior("flooring")
                        }}
                        className={
                          isActiveInterior === "flooring"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Flooring
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.kitchen)
                          setIsActiveInterior("kitchen")
                        }}
                        className={
                          isActiveInterior === "kitchen"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Kitchen
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.bathroom)
                          setIsActiveInterior("bathroom")
                        }}
                        className={
                          isActiveInterior === "bathroom"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Bathrooms
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.cabinet)
                          setIsActiveInterior("cabinet")
                        }}
                        className={
                          isActiveInterior === "cabinet"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Cabinet Installation
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.basement)
                          setIsActiveInterior("basement")
                        }}
                        className={
                          isActiveInterior === "basement"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Basements
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.painting)
                          setIsActiveInterior("painting")
                        }}
                        className={
                          isActiveInterior === "painting"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Painting
                      </button>
                    </li>

                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedInteriorService(services.backsplash)
                          setIsActiveInterior("backsplash")
                        }}
                        className={
                          isActiveInterior === "backsplash"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Backplash
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {selectedInteriorService ? (
                <div className={styles.service}>
                  <div className={styles.imageContainer}>
                    <img
                      src={selectedInteriorService.img}
                      className={styles.interiorImage}
                      alt=""
                    />
                    <p className={styles.serviceText}>
                      {selectedInteriorService.text}
                    </p>
                  </div>
                </div>
              ) : null}
            </section>
            <section className={styles.servicesSection}>
              <div className={styles.servicesContainer}>
                <div className={styles.servicesContent}>
                  <h1 className={styles.servicesTitle}>Exterior Services</h1>
                  <ul className={styles.renovationList}>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedExteriorService(services.fence)
                          setIsActiveExterior("fence")
                        }}
                        className={
                          isActiveExterior === "fence"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Fences
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedExteriorService(services.deck)
                          setIsActiveExterior("deck")
                        }}
                        className={
                          isActiveExterior === "deck"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Decks
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedExteriorService(services.patio)
                          setIsActiveExterior("patio")
                        }}
                        className={
                          isActiveExterior === "patio"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Patios
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedExteriorService(services.interlock)
                          setIsActiveExterior("interlock")
                        }}
                        className={
                          isActiveExterior === "interlock"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Interlock
                      </button>
                    </li>
                    <li className={styles.renovationListItem}>
                      <button
                        onClick={() => {
                          setSelectedExteriorService(services.siding)
                          setIsActiveExterior("siding")
                        }}
                        className={
                          isActiveExterior === "siding"
                            ? "active serviceBtn"
                            : "serviceBtn"
                        }
                      >
                        Siding
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {selectedExteriorService ? (
                <div className={styles.service}>
                  <div className={styles.imageContainer}>
                    <img
                      src={selectedExteriorService.img}
                      className={styles.interiorImage}
                      alt=""
                    />
                    <p className={styles.serviceText}>
                      {selectedExteriorService.text}
                    </p>
                  </div>
                </div>
              ) : null}
            </section>
          </SRLWrapper>
        </FadeInSection>
      </div>
    </div>
  )
}

export default Services
